import SwiggyIcon from "../assets/images/icons/Swiggy.png";
import ZomatoIcon from "../assets/images/icons/Zomato.png";
import DunzoIcon from "../assets/images/icons/Dunzo.png";
import FoodPandaIcon from "../assets/images/icons/FoodPanda.png";
import AmazonIcon from "../assets/images/icons/Amazon.png";
import WhatsappIcon from "../assets/images/icons/Whatsapp.png";
import ThriveIcon from "../assets/images/icons/Thrive.png";
import SwiggyLogo from "../assets/images/logo/Swiggy.png";
import ZomatoLogo from "../assets/images/logo/Zomato.png";
import DunzoLogo from "../assets/images/logo/Dunzo.png";
import FoodPandaLogo from "../assets/images/logo/FoodPanda.png";
import AmazonLogo from "../assets/images/logo/Amazon.png";
import whatsappLogo from "../assets/images/logo/Whatsapp.png";
import ThriveLogo from "../assets/images/logo/Thrive.png";
export const ZOMATO = {
  id: 1,
  name: "zomato",
  label: "Zomato",
  img: ZomatoIcon,
  logo: ZomatoLogo
};
export const SWIGGY = {
  id: 2,
  name: "swiggy",
  label: "Swiggy",
  img: SwiggyIcon,
  logo: SwiggyLogo
};
export const DUNZO = {
  id: 3,
  name: "dunzo",
  label: "Dunzo",
  img: DunzoIcon,
  logo: DunzoLogo
};
export const FOOD_PANDA = {
  id: 4,
  name: "foodPanda",
  label: "FoodPanda",
  img: FoodPandaIcon,
  logo: FoodPandaLogo
};
export const AMAZON_RESTAURANTS = {
  id: 5,
  name: "amazonRestaurants",
  label: "Amazon Restaurants",
  img: AmazonIcon,
  logo: AmazonLogo
};
export const WHATSAPP = {
  id: 6,
  name: "whatsapp",
  label: "Whatsapp",
  img: WhatsappIcon,
  logo: whatsappLogo
};
export const THRIVE = {
  id: 7,
  name: "thrive",
  label: "Thrive",
  img: ThriveIcon,
  logo: ThriveLogo
};
export const ALL_CHANNELS = {
  label: "All Channels",
  name: "all"
};
// export const URBAN_PIPER = {
//   id: 5,
//   name: "urbanpiper",
//   label: "urbanpiper",
//   img: ""
// };
export const CHANNELS = [
  ZOMATO,
  SWIGGY,
  DUNZO,
  FOOD_PANDA,
  AMAZON_RESTAURANTS,
  WHATSAPP,
  THRIVE
];
